export const START_LESSON = 'START_LESSON';
export const END_LESSON = 'END_LESSON';
export const OPEN_THEMES_SIDEBAR = 'OPEN_THEMES_SIDEBAR';
